import React, { useState } from "react"
import { getAPIBaseURL } from "../services/helpers"
import { postData } from "../services/request"

const DisputeForm = ({ postId, onSuccess }) => {
  const [showForm, setShowForm] = useState(false)
  const [subject, setSubject] = useState("")
  const [message, setMessage] = useState("")
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState("")
  const [success, setSuccess] = useState("")

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")
    setSuccess("")

    if (!postId) {
      setError("Request ID is missing. Please refresh the page and try again.")
      return
    }

    if (!subject.trim() || !message.trim()) {
      setError("Please fill in all fields")
      return
    }

    if (subject.trim().length < 3) {
      setError("Subject must be at least 3 characters")
      return
    }

    if (message.trim().length < 10) {
      setError("Message must be at least 10 characters")
      return
    }

    setSubmitting(true)
    const url = `${getAPIBaseURL()}/v1/disputes`
    const headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
    const params = new URLSearchParams()
    params.append('postId', postId.toString().trim())
    params.append('subject', subject.trim())
    params.append('message', message.trim())
    const res = await postData(url, headers, params.toString())
    setSubmitting(false)

    if (res.error == "") {
      if (res.result.status === 200) {
        setSuccess("Dispute submitted successfully. An admin will review it shortly.")
        setSubject("")
        setMessage("")
        setShowForm(false)
        if (onSuccess) {
          onSuccess()
        }
      } else {
        setError(res.result.data?.message || res.result.data?.data || 'Failed to submit dispute')
      }
    } else {
      setError(res.result?.data?.message || res.result?.data?.data || 'Network error')
    }
  }

  if (!showForm) {
    return (
      <div className="mt-4">
        <button
          onClick={() => setShowForm(true)}
          className="rounded-lg border border-red-300 bg-red-50 px-4 py-2 text-sm font-medium text-red-700 hover:bg-red-100"
        >
          File a Dispute
        </button>
      </div>
    )
  }

  return (
    <div className="mt-4 rounded-lg border border-gray-200 bg-gray-50 p-4">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="text-sm font-semibold text-gray-900">File a Dispute</h3>
        <button
          onClick={() => {
            setShowForm(false)
            setSubject("")
            setMessage("")
            setError("")
            setSuccess("")
          }}
          className="text-sm text-gray-500 hover:text-gray-700"
        >
          Cancel
        </button>
      </div>

      {error && (
        <div className="mb-3 rounded-lg border border-red-200 bg-red-50 p-2 text-xs font-medium text-red-700">
          {error}
        </div>
      )}

      {success && (
        <div className="mb-3 rounded-lg border border-green-200 bg-green-50 p-2 text-xs font-medium text-green-700">
          {success}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-3">
        <div>
          <label htmlFor="dispute-subject" className="mb-1 block text-xs font-medium text-gray-900">
            Subject <span className="text-red-600">*</span>
          </label>
          <input
            id="dispute-subject"
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            placeholder="Brief description of the issue"
            maxLength={200}
            className="block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus:border-black focus:outline-none focus:ring-2 focus:ring-black"
            required
          />
          <p className="mt-1 text-xs text-gray-500">{subject.length}/200 characters</p>
        </div>

        <div>
          <label htmlFor="dispute-message" className="mb-1 block text-xs font-medium text-gray-900">
            Message <span className="text-red-600">*</span>
          </label>
          <textarea
            id="dispute-message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Please provide details about your complaint..."
            rows={4}
            maxLength={5000}
            className="block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus:border-black focus:outline-none focus:ring-2 focus:ring-black resize-none"
            required
          />
          <p className="mt-1 text-xs text-gray-500">{message.length}/5000 characters</p>
        </div>

        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => {
              setShowForm(false)
              setSubject("")
              setMessage("")
              setError("")
              setSuccess("")
            }}
            className="flex-1 rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={submitting}
            className="flex-1 rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {submitting ? "Submitting..." : "Submit Dispute"}
          </button>
        </div>
      </form>
    </div>
  )
}

export default DisputeForm

